import { render, staticRenderFns } from "./UnsavedChangesDrawer.vue?vue&type=template&id=2c469e5c"
import script from "./UnsavedChangesDrawer.vue?vue&type=script&lang=js"
export * from "./UnsavedChangesDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports